import { Link } from 'react-router-dom';
import { useDashT } from '../lib/dashboardStrings';

export default function BookNowButton({ labelKey, testId }) {
  const dt = useDashT();
  const label = labelKey || dt('Book now');
  return (
    <Link to="/boka" data-testid={testId} style={{ backgroundColor: '#1A8A4A', color: '#FFFFFF' }} className="px-4 py-2 rounded-full text-sm font-semibold whitespace-nowrap inline-block">
      {label}
    </Link>
  );
}
